export const engagementCampaignsDataV2 = "/engagement/campaigns_data_v2";
